import { defineMessages } from 'react-intl';

export default defineMessages({
  publishYourCv: {
    id: 'global_cvpublishlink',
    defaultMessage: 'Publish your CV',
    description: 'jobs',
  },
});



// WEBPACK FOOTER //
// ./app/Serp/components/PublishYourCv/messages.js